import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isProTier } from '@/lib/tier';
import { Button } from '@/components/ui/button';
import { LanguageToggle } from '@/components/LanguageToggle';
import { Sparkles, Zap } from 'lucide-react';
import { NavLink } from './NavLink';
import { NAV_ITEMS } from './navItems';
import { UserMenu } from './UserMenu';

// Desktop (md+) navigation: primary links + right-hand action cluster.
export const DesktopNav = ({ user, onLogout }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isPro = isProTier(user?.subscription_tier);

  return (
    <>
      <nav className="hidden md:flex items-center gap-5">
        {NAV_ITEMS.map((it) => (
          (!it.auth || user) && (
            <NavLink key={it.testid} to={it.to} label={t(it.labelKey)} Icon={it.Icon} testid={it.testid} />
          )
        ))}
        <NavLink to="/pricing" label={t('nav.pricing')} testid="nav-pricing" />
      </nav>

      <div className="hidden md:flex items-center gap-3">
        <LanguageToggle />
        {!user && (
          <>
            <Button variant="ghost" onClick={() => navigate('/login')} data-testid="nav-login-btn" className="text-white hover:text-[#48CAE4] hover:bg-white/5">{t('nav.login')}</Button>
            <Button onClick={() => navigate('/register')} data-testid="nav-signup-btn" className="bg-[#00B4D8] hover:bg-[#48CAE4] text-black font-semibold rounded-xl">{t('nav.getStarted')}</Button>
          </>
        )}
        {user && (
          <>
            <button onClick={() => navigate('/pricing')} data-testid="nav-credits-chip"
              className="flex items-center gap-1.5 text-sm font-data px-2.5 py-1.5 rounded-full bg-[#00B4D8]/10 border border-[#00B4D8]/30 text-[#48CAE4] hover:bg-[#00B4D8]/15 transition-colors"
              title={t('nav.creditsTitle')}>
              <Zap className="w-3.5 h-3.5" /> <span className="font-semibold text-white" data-testid="nav-credits-count">{user.credits ?? 0}</span>
            </button>
            {!isPro && (
              <Button onClick={() => navigate('/pricing')} data-testid="nav-upgrade-btn"
                className="bg-[#FF6B35] hover:bg-[#FFB020] text-black font-semibold rounded-xl">
                <Sparkles className="w-4 h-4 mr-1" /> {t('nav.upgrade')}
              </Button>
            )}
            <UserMenu user={user} onNavigate={navigate} onLogout={onLogout} />
          </>
        )}
      </div>
    </>
  );
};
